import {useSuspenseQuery} from '@tanstack/react-query';
import {injectRecentSort, prepareSearchParams, reportListSchema} from 'shared';

import {api} from '@/lib/ky';
import {extractPagination} from '@/utils/extractPagination';

import {reportKeys} from './queryKeys';

import type {
  ExtractFnReturnType,
  QueryConfig,
  QueryConfig2,
} from '@/lib/react-query';

export const getReports = async (params: QueryParams) => {
  const res = await api.get(`reports`, {
    searchParams: prepareSearchParams(injectRecentSort(params)),
  });
  const data = await res.json();
  const pagination = extractPagination(res);
  return [reportListSchema.parse(data), pagination] as const;
};

export const useReports = (
  params: QueryParams,
  config?: QueryConfig<QueryFnType>
) => {
  return useSuspenseQuery<ExtractFnReturnType<QueryFnType>>({
    ...config,
    queryKey: reportKeys.list(params),
    queryFn: () => getReports(params),
  });
};
export const useReportsLoader = (config: QueryConfig2<QueryFnType>) => {
  return useSuspenseQuery<ExtractFnReturnType<QueryFnType>>(config);
};

type QueryFnType = typeof getReports;
type QueryParams = Parameters<typeof reportKeys.list>[0];
